let RecaptchaHandler = {
    handle: function (data, callback) {
        if (typeof recaptchaKey === 'undefined') {
            return callback(data);
        }

        if (data.recaptcha) {
            return callback(data);
        }

        grecaptcha.ready(function() {
            grecaptcha.execute(recaptchaKey).then(function(recaptcha) {
                data.recaptcha = recaptcha;
                callback(data)
            });
        });

        return false;
    }
};

if (typeof module !== "undefined") {
    module.exports = RecaptchaHandler;
}
